import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin';
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

// small image that appears as you scroll
const warriorJs = () => {
  const warriorShortScreen = document.getElementsByClassName(
    'warrior-short-screen'
  );
  if (warriorShortScreen.length > 0) {
    gsap.to('.warrior-short-screen', {
      scrollTrigger: {
        trigger: '.warrior-attend',
        start: 'bottom 65%',
        end: '+=500px',
        scrub: true,
        toggleActions: 'restart none reverse none',
      },
      backgroundColor: 'rgba(0,0,0,0)',
    });
  }

  // click arrow in the hero to scroll to the sign up buttons at the bottom of the page
  const warrow = document.getElementsByClassName('warrow');
  if (warrow.length > 0) {
    $('.warrow').on('click', function () {
      let position = $('#registration').offset().top;
      $('body, html').animate(
        {
          scrollTop: position,
        },
        2
      );
    });
  }

  // hero countdown clock
  const countdown = document.getElementsByClassName('countdown');
  if (countdown.length > 0) {
    let cDate = countdown[0].getAttribute('data-date');
    let countDownDate = parseInt(cDate) * 1000;

    let x = setInterval(function () {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element ids
      if (seconds < 10) {
        document.getElementById('seconds').innerHTML = '0' + seconds;
      } else {
        document.getElementById('seconds').innerHTML = seconds;
      }
      if (minutes < 10) {
        document.getElementById('minutes').innerHTML = '0' + minutes;
      } else {
        document.getElementById('minutes').innerHTML = minutes;
      }
      if (hours < 10) {
        document.getElementById('hours').innerHTML = '0' + hours;
      } else {
        document.getElementById('hours').innerHTML = hours;
      }
      if (days < 10) {
        document.getElementById('days').innerHTML = '0' + days;
      } else {
        document.getElementById('days').innerHTML = days;
      }
    }, 1000);

    const displayCountdown = new gsap.timeline();
    displayCountdown
      .fromTo(
        $('.countdown'),
        { opacity: 0 },
        { duration: 3, ease: 'power4.out', opacity: 1 }
      )
      .fromTo(
        $('.markYourCalendar'),
        { opacity: 0 },
        { duration: 3, ease: 'power4.out', opacity: 1 },
        '-=2'
      );
    displayCountdown.play();
  }

  // scrolling banner "See you at Warrior"
  const warTbDiv = document.getElementsByClassName('war-tb-div');
  if (warTbDiv.length > 0) {
    if ($(window).width() > 1024) {
      $('.war-tb-div').addClass('move-words');
    }
    let atX = document.getElementById('atX');
    if (atX) {
      gsap.to('.at-x-container', {
        scrollTrigger: {
          trigger: '.at-x-container',
          start: 'top 95%',
          onEnter: () => $('.at-x-container').addClass('move-text'),
          onLeave: () => $('.at-x-container').removeClass('move-text'),
          onEnterBack: () => $('.at-x-container').addClass('move-text'),
          onLeaveBack: () => $('.at-x-container').removeClass('move-text'),
        },
      });
    }
  }

  // informational slideshow
  const warriorSlider = document.getElementsByClassName('warrior-slider');
  if (warriorSlider.length > 0) {
    $('.warrior-slider').slick({
      slidesToShow: 1,
      autoplay: false,
      infinite: true,
      centerMode: true,
      focusOnSelect: true,
      arrows: true,
      prevArrow: $('.wp'),
      nextArrow: $('.wn'),
    });
  }

  // image gallery nav/for slideshow
  const display = document.getElementsByClassName('warrior-image-display');
  const displayNav = document.getElementsByClassName('warrior-left-nav');

  if (display.length > 0 && displayNav.length > 0) {
    $('.warrior-image-display').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.warrior-left-nav',
    });

    const warriorNav = $('.warrior-left-nav');
    const warriorNavSettings = {
      slidesToShow: 7,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: '.warrior-image-display',
      dots: false,
      centerMode: true,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 7,
            vertical: false,
            centerMode: false,
            infinite: false,
          },
        },
      ],
    };
    warriorNav.slick(warriorNavSettings);
    $(window).on('resize', function () {
      if ($(window).width() > 950) {
        return;
      }
      if (!warriorNav.hasClass('slick-initialized')) {
        return warriorNav.slick(warriorNavSettings);
      }
    });
  }

  // slider on half the screen in module (near top of page)
  const duoLeft = document.getElementsByClassName('duo-left');
  if (duoLeft.length > 0) {
    $('.duo-left').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
    });
  }

  // two sliders autoplay side by side
  const wb1 = document.getElementsByClassName('wb-1');
  const wb2 = document.getElementsByClassName('wb-2');
  if (wb1.length > 0 && wb2.length > 0) {
    $('.wb-1').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      infinite: true,
      slidesToShow: 1,
    });
    $('.wb-2').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 5120,
      infinite: true,
      slidesToShow: 1,
    });
  }

  // hero drawSVG
  var war = document.getElementById('war-w');
  if (war) {
    const tlWarrior = new gsap.timeline();
    tlWarrior
      .fromTo($('#war-w'), { drawSVG: '0%' }, { duration: 3, drawSVG: '100%' })
      .fromTo(
        $('#war-a'),
        { drawSVG: '0%' },
        { duration: 3, drawSVG: '100%' },
        '-=3'
      )
      .fromTo(
        $('#war-r1'),
        { drawSVG: '0%' },
        { duration: 3, drawSVG: '100%' },
        '-=3'
      )
      .fromTo(
        $('#war-r2'),
        { drawSVG: '0%' },
        { duration: 3, drawSVG: '100%' },
        '-=3'
      )
      .fromTo(
        $('#war-i'),
        { drawSVG: '0%' },
        { duration: 3, drawSVG: '100%' },
        '-=3'
      )
      .fromTo(
        $('#war-o'),
        { drawSVG: '0%' },
        { duration: 3, drawSVG: '100%' },
        '-=3'
      )
      .fromTo(
        $('#war-r3'),
        { drawSVG: '0%' },
        { duration: 3, drawSVG: '100%' },
        '-=3'
      );
    tlWarrior.play();
  }

  // warrior video player #1
  var warVideoOne = document.getElementById('warrior-video');
  if (warVideoOne) {
    $('#warrior-video')[0].addEventListener('playing', function () {
      gsap.to($('.play-pause'), 0.2, {
        opacity: '0',
        ease: 'power4.out',
      });
      $('.play-pause').removeClass('ready');
    });
    $('#warrior-video')[0].addEventListener('pause', function () {
      gsap.to($('.play-pause'), 0.2, {
        opacity: '1',
        ease: 'power4.out',
      });
      $('.play-pause').addClass('ready');
    });
  }

  // warrior video player #2
  var warVideoTwo = document.getElementById('warrior-video2');
  if (warVideoTwo) {
    $('#warrior-video2')[0].addEventListener('playing', function () {
      gsap.to($('.play-pause2'), 0.2, {
        opacity: '0',
        ease: 'power4.out',
      });
      $('.play-pause2').removeClass('ready');
    });
    $('#warrior-video2')[0].addEventListener('pause', function () {
      gsap.to($('.play-pause2'), 0.2, {
        opacity: '1',
        ease: 'power4.out',
      });
      $('.play-pause2').addClass('ready');
    });
  }

  $(document).ready(function () {
    $(() => {
      // functions for videos to remove overlay, play, pause and play again.
      // warrior video 1
      if ($('.warrior-video')[0]) {
        $('.warrior-play').on('click', function () {
          gsap.to($('.warrior-play'), 0.5, {
            opacity: '0',
            display: 'none',
            ease: 'power4.out',
          });
          gsap.to($('.play-pause'), 1.2, {
            opacity: '1',
            display: 'block',
            ease: 'power4.out',
          });
          $('.play-pause').addClass('ready');
        });
      }
      if ($('.warrior-video')[0]) {
        $('.play-pause').on('click', function () {
          if ($('.play-pause').hasClass('ready')) {
            $('#warrior-video')[0].play();
            gsap.to($('.play-pause'), 0.2, {
              opacity: '0',
              ease: 'power4.out',
            });
            $('.play-pause').removeClass('ready');
          } else {
            $('#warrior-video')[0].pause();
            $('.play-pause').addClass('ready');
            gsap.to($('.play-pause'), 0.2, {
              opacity: '1',
              ease: 'power4.out',
            });
          }
        });
      }
      if ($('.play-pause')[0]) {
        if ($('#warrior-video').paused) {
          gsap.to($('.play-pause'), 0.2, {
            opacity: '1',
            ease: 'power4.out',
          });
        } else {
          gsap.to($('.play-pause'), 0.2, {
            opacity: '0',
            ease: 'power4.out',
          });
        }
      }
      // warrior video 2
      if ($('.warrior-play2')[0]) {
        $('.warrior-play2').on('click', function () {
          gsap.to($('.warrior-play2'), 0.5, {
            opacity: '0',
            display: 'none',
            ease: 'power4.out',
          });
          gsap.to($('.play-pause2'), 1.2, {
            opacity: '1',
            display: 'block',
            ease: 'power4.out',
          });
          $('.play-pause2').addClass('ready');
        });
      }
      if ($('#warrior-video2')[0]) {
        $('.play-pause2').on('click', function () {
          if ($('.play-pause2').hasClass('ready')) {
            $('#warrior-video2')[0].play();
            gsap.to($('.play-pause2'), 0.2, {
              opacity: '0',
              ease: 'power4.out',
            });
            $('.play-pause2').removeClass('ready');
          } else {
            $('#warrior-video2')[0].pause();
            $('.play-pause2').addClass('ready');
            gsap.to($('.play-pause2'), 0.2, {
              opacity: '1',
              ease: 'power4.out',
            });
          }
        });
      }
      if ($('#warrior-video2')[0]) {
        if ($('#warrior-video2').paused) {
          gsap.to($('.play-pause2'), 0.2, {
            opacity: '1',
            ease: 'power4.out',
          });
        } else {
          gsap.to($('.play-pause2'), 0.2, {
            opacity: '0',
            ease: 'power4.out',
          });
        }
      }
    });
  });
};
export default warriorJs;
